import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputNumberComponent } from './form-input-number.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormInputNumberComponent
  ],
  imports: [
    CommonModule,
    InputNumberModule,
    FormInputErrorModule,
    SharedModule,
    FormsModule,
  ],
  exports: [
    FormInputNumberComponent
  ]
})
export class FormInputNumberModule { }
